module.exports = __webpack_public_path__ + "static/media/04.819f005a.png";